<template>
  <div class="two-letter-list">
    <span class="label">{{ label }}</span>
    <div class="word-list">
      <div v-for="(word, index) in words" :key="index" class="word">
        {{ word.toUpperCase() }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TwoLetterList",
  props: {
    label: {
      type: String,
      default: ""
    },
    words: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.two-letter-list {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap; /* allows the label and word-list to wrap if needed */
}

.label {
  margin-right: 10px;
  white-space: nowrap; /* keep label on one line */
}

.word-list {
  display: flex;
  flex-wrap: wrap;   /* wrap words into multiple lines */
  gap: 8px;          /* spacing between circles */
  flex: 1;           /* take remaining width */
}

.word {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  font-size: 12px;
  border-radius: 50%;
  background-color: #ccc; /* gray background */
  text-transform: uppercase;
  font-family: sans-serif;
}
</style>
